import React from 'react';

import Image from 'next/image';
import { Text, Button } from '@BICE_Vida/components';
import { Container, Row, Col } from '../../../designSystem';
import { benefitsPageTexts } from '../../../utils/generalTexts';

import Section from '../../Section';

import styles from './BenefitsTeleHealth.module.scss';

import componentsId from '../../../utils/componentsId';
import { BENEFITS_CARD_TELEHEALTH, PDFS } from '@/utils/assets';

const BenefitsTeleHealth = () => {
  const handleLinkClick = () => {
    const url = process.env.assetsUrl + PDFS.TELEHEALTH;
    window.open(url, '_blank');
  };

  return (
    <Section id={componentsId.benefits.telehealth.section} customClass={styles.benefits}>
      <Container className={styles.benefits_telehealth_card_container}>
        <div className={styles.benefits_card_telehealth_info}>
          <div id="id" className={styles.benefits_pyme_card}>
            <Image
              src={BENEFITS_CARD_TELEHEALTH}
              className={styles.benefits_telehealth_card_img}
              alt="bicevida beneficios"
              width={474}
              height={571}
            />
          </div>
        </div>
        <div className={styles.benefits_telehealth_card_list_container}>
          <div className={styles.benefits_telehealth_card_texts}>
            <Text className={styles.benefits_telehealth_title}>
              {benefitsPageTexts.telehealth.title}
            </Text>
          </div>
          <div className={styles.telehealth_list}>
            <ul>
              {benefitsPageTexts.telehealth.list.map((benefit, index) => (
                <li key={`benefits${index}`}>
                  <div className={styles.list_text}>{benefit}</div>
                </li>
              ))}
            </ul>
          </div>
          <div className={styles.benefits_telehealth_btn_container}>
            <Button
              icon="open_in_new"
              iconPosition="right"
              onClick={handleLinkClick}
              size="large"
              text="Ver detalles del beneficio"
              variant="text"
            />
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default BenefitsTeleHealth;
